const languageSwitches = [...document.querySelectorAll('.js-language-switch')];
languageSwitches.map(languageSwitch => languageSwitch.addEventListener('change', () => languageSwitch.submit()));